module.exports = __webpack_public_path__ + "img/victron_smart_24_24_12.5225c609.png";